import Header from './Header';
import GreetSection from './GreetSection';
import Skills from './Skills';
import Contact from './Contact';
import Footer from './Components/Footer';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <GreetSection />
      <Skills />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
